export const MuiRadio = {
  styleOverrides: {
    root: {
      '& .MuiSvgIcon-root': { fontSize: 28 },
      '&.Mui-checked': {
        color: '#1010EB',
      },
      '&.Mui-disabled': {
        color: '#0000004C',
      },
    },
  },
};
